import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const ContactInfo = ({ formData, handlePhoneChange, handleInputChange }) => {
  return (
    <div className="form-group">
      <div>
        <label htmlFor="phone">Telefon <span className="optional">(Optional)</span></label>
        <PhoneInput
          country={'de'} // Default country
          value={formData.phone}
          onChange={handlePhoneChange}
          inputProps={{
            name: 'phone',
            required: false,
            autoFocus: true,
          }}
        />
      </div>
      <div>
        <label htmlFor="email">E-Mail <span className="optional">(Optional)</span></label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

export default ContactInfo;
